/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path apicaller
 * @description Session constants for the APIs
 */
import { SESSION_TOKEN } from "./api-consts";
// Sessiontoken (=jwt) is passed either in http header or in cookie,
// configured in server. If cookie is used, no token is stored to
// localstorage
const initSession = (sessionToken: string | null): void => {
  if (!sessionToken) {
    throw new Error("Session initialization failed");
  }
  window.sessionStorage.setItem(SESSION_TOKEN, sessionToken);
};
const destroySession = (): void => {
  window.sessionStorage.removeItem(SESSION_TOKEN);
};
const getSessionToken = (): string | null => {
  return window.sessionStorage.getItem(SESSION_TOKEN);
};
export default {
  initSession,
  getSessionToken,
  destroySession,
};
